/**
 * โคตรมหาเฮง logomark (โลโก้จริง raster วงกลม) + ป้ายชื่อ "โคตรมหาเฮง168" (optional).
 *
 *   <Logo />                          → mark only
 *   <Logo wordmark />                 → mark + "โคตรมหาเฮง168"
 *   <Logo white />                    → ป้ายชื่อสีขาว (สำหรับพื้น gradient)
 *   <Logo wordmark sub="PayPilot" />  → เพิ่มป้ายผลิตภัณฑ์ใต้ชื่อ
 *   <Logo surface="dark" wordmark />  → ทอง/อ่อน สำหรับ sidebar ดำ (Luxury Ledger)
 *
 * โลโก้เป็นภาพจริง (/khotmahaheng-logo.jpg) → ใช้ได้ทุกพื้น; สีปรับเฉพาะตัวหนังสือ.
 */
interface Props {
  /** Tailwind height class for the mark, e.g. "h-8" (default). */
  size?: string;
  white?: boolean;
  wordmark?: boolean;
  /**
   * พื้นที่โลโก้วางอยู่. `'dark'` = ทอง/อ่อน ให้เห็นบน sidebar ดำ.
   */
  surface?: 'light' | 'dark';
  /** ป้ายผลิตภัณฑ์เล็กใต้ชื่อ. */
  sub?: string;
  className?: string;
}

export function Logo({ size = 'h-8', white = false, wordmark = false, surface = 'light', sub, className = '' }: Props) {
  const dark = surface === 'dark';
  const wordColor = white ? 'text-white' : dark ? 'text-[#e0d9c8]' : 'text-ink';
  const subColor = white ? 'text-white/80' : dark ? 'text-[#8f877e]' : 'text-warm-gray';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* โลโก้จริงของโคตรมหาเฮง (raster) — วงกลม ใช้ได้ทุกพื้น */}
      <img src="/khotmahaheng-logo.jpg" alt="โคตรมหาเฮง 168" className={`${size} w-auto rounded-full`} />
      {wordmark && (
        <span className="leading-none">
          <span className={`font-display font-semibold text-lg ${wordColor}`}>โคตรมหาเฮง168</span>
          {sub && <span className={`block text-[10px] tracking-[.2em] uppercase mt-0.5 ${subColor}`}>{sub}</span>}
        </span>
      )}
    </span>
  );
}
